import { useState } from 'react';
import { useSearchParams } from 'react-router';
import { Tabs, tabId, tabPanelId } from '@agency/ui';
import { NotFoundTab } from './not-found-tab.tsx';
import { OverviewTab } from './overview-tab.tsx';
import { RedirectDrawer, type RedirectDraft } from './redirect-drawer.tsx';
import { RedirectsTab } from './redirects-tab.tsx';
import { useAuth } from '../../lib/auth.tsx';

type Tab = 'overview' | 'redirects' | 'not-found';
const TABS: { id: Tab; label: string }[] = [{ id: 'overview', label: 'Overview' }, { id: 'redirects', label: 'Redirects' }, { id: 'not-found', label: '404 tracking' }];

export function SeoPage() {
  const { can } = useAuth();
  const [params, setParams] = useSearchParams();
  const tab = TABS.find((t) => t.id === params.get('tab'))?.id ?? 'overview';
  const setTab = (t: Tab) => setParams(t === 'overview' ? {} : { tab: t }, { replace: true });
  // One create form serves both the Redirects tab and the 404 list, so it lives here.
  const [draft, setDraft] = useState<RedirectDraft | null>(null);
  return (
    <>
      <div className="pagehead">
        <div><h1>SEO</h1><p>What search engines can reach on this site: page checks, redirects and addresses that return 404. {can('seo.manage') ? '' : 'You have read-only access.'}</p></div>
      </div>
      <Tabs<Tab> id="seo-tabs" label="SEO sections" tabs={TABS} value={tab} onChange={setTab} />
      <div role="tabpanel" id={tabPanelId('seo-tabs')} aria-labelledby={tabId('seo-tabs', tab)} style={{ paddingTop: 16 }}>
        {tab === 'overview' ? <OverviewTab goTo={setTab} /> : null}
        {tab === 'redirects' ? <RedirectsTab onCreate={() => setDraft({ source: '', destination: '' })} /> : null}
        {tab === 'not-found' ? <NotFoundTab onCreate={setDraft} /> : null}
      </div>
      <RedirectDrawer draft={draft} onClose={() => setDraft(null)} />
    </>
  );
}
